module.exports = __webpack_public_path__ + "static/media/arrowBlue.fdd244e3.svg";